module.exports = __webpack_public_path__ + "img/student_15.5b054ea4.png";